export default __webpack_public_path__ + "static/media/nft8.d0447275.png";